var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42124 4.12227C4.42124 3.36957 5.23605 2.89914 5.8879 3.27549L13.9546 7.93278C14.6064 8.30912 14.6064 9.24999 13.9546 9.62634L5.8879 14.2836C5.23605 14.66 4.42124 14.1895 4.42124 13.4369L4.42124 4.12227Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52173 22.6743C3.52173 22.098 3.98891 21.6309 4.56521 21.6309L24.913 21.6309C25.4893 21.6309 25.9565 22.098 25.9565 22.6743C25.9565 23.2506 25.4893 23.7178 24.913 23.7178L4.56521 23.7178C3.98891 23.7178 3.52173 23.2506 3.52173 22.6743Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8261 16.4126C10.8261 15.8363 11.2933 15.3691 11.8696 15.3691L24.9131 15.3691C25.4894 15.3691 25.9565 15.8363 25.9565 16.4126C25.9565 16.9889 25.4894 17.4561 24.9131 17.4561L11.8696 17.4561C11.2933 17.4561 10.8261 16.9889 10.8261 16.4126Z",
    fill: "#B08C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1739 10.1529C19.1739 9.57656 19.6411 9.10938 20.2174 9.10938H24.913C25.4893 9.10938 25.9565 9.57656 25.9565 10.1529C25.9565 10.7292 25.4893 11.1963 24.913 11.1963H20.2174C19.6411 11.1963 19.1739 10.7292 19.1739 10.1529Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramsActive);
export default __webpack_public_path__ + "static/media/programs-active.8b06acb5efcc1604db0c59afcab1bd19.svg";
export { ForwardRef as ReactComponent };